export default "__VITE_ASSET__CkgzJ37X__"